import { useTranslation } from 'react-i18next';
import { type User } from '@/types';
import { RoleId } from '@/types/roles';

const ROLE_TRANSLATION_MAP: Record<RoleId, string> = {
  [RoleId.ADMINISTRATOR]: 'users.roles.administrator',
  [RoleId.MANAGER]: 'users.roles.manager',
  [RoleId.ANALYST]: 'users.roles.analyst',
  [RoleId.INSPECTOR]: 'users.roles.inspector',
  [RoleId.VIEWER]: 'users.roles.viewer',
};

export const useRoleTranslation = () => {
  const { t } = useTranslation();

  const getRoleDisplayName = (user: User | null | undefined) => {
    if (!user || !user.role) {
      return '';
    }

    if (user.role in ROLE_TRANSLATION_MAP) {
      return t(ROLE_TRANSLATION_MAP[user.role]);
    }

    // Иначе используем role_display из БД
    return user.role_display || '';
  };

  return { getRoleDisplayName, ROLE_TRANSLATION_MAP };
};
